import { useEffect, useState } from "react";
import { format, parseISO, isValid } from "date-fns";
import { tr } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

const tarih = (v) => (v && isValid(parseISO(v)) ? parseISO(v) : undefined);
const goster = (v) => (tarih(v) ? format(tarih(v), "dd.MM.yyyy") : "");
const maskele = (r) => [r.slice(0, 2), r.slice(2, 4), r.slice(4, 8)].filter(Boolean).join(".");

const cozumle = (r) => {
  if (r.length === 6) r = `${r.slice(0, 4)}20${r.slice(4)}`;
  if (r.length !== 8) return null;
  const iso = `${r.slice(4)}-${r.slice(2, 4)}-${r.slice(0, 2)}`;
  return tarih(iso) && format(tarih(iso), "yyyy-MM-dd") === iso ? iso : null;
};

// Klavyeyle gg.aa.yyyy yazılır (Tab ile geçilir), takvim düğmesi isteğe bağlı; değer yyyy-mm-dd
export const TarihInput = ({ value, onChange, className, min, max, disabled, placeholder, required, ...rest }) => {
  const [acik, setAcik] = useState(false);
  const [metin, setMetin] = useState(goster(value));
  useEffect(() => { setMetin(goster(value)); }, [value]);
  const secili = tarih(value);
  const tid = rest["data-testid"];
  const aralikta = (iso) => (!min || iso >= min) && (!max || iso <= max);
  const bildir = (iso) => onChange?.({ target: { value: iso } });
  const sec = (d) => { bildir(d ? format(d, "yyyy-MM-dd") : ""); setAcik(false); };
  const yaz = (e) => {
    const r = e.target.value.replace(/\D/g, "").slice(0, 8);
    setMetin(maskele(r));
    const iso = r.length === 8 && cozumle(r);
    if (iso && aralikta(iso)) bildir(iso);
    else if (!r.length && !required) bildir("");
  };
  const birak = () => {
    const iso = cozumle(metin.replace(/\D/g, ""));
    if (iso && aralikta(iso)) { if (iso !== value) bildir(iso); setMetin(goster(iso)); } else setMetin(goster(value));
  };
  const kapali = [tarih(min) && { before: tarih(min) }, tarih(max) && { after: tarih(max) }].filter(Boolean);
  return (
    <Popover open={acik} onOpenChange={setAcik}>
      <div className={cn("relative flex h-9 w-full items-center rounded-md border border-input bg-transparent text-sm focus-within:ring-1 focus-within:ring-ring", disabled && "opacity-50", className)}>
        <PopoverTrigger asChild>
          <button type="button" tabIndex={-1} disabled={disabled} aria-label="Takvimi aç" data-testid={tid ? `${tid}-takvim` : undefined} className="pl-3 pr-2 h-full text-muted-foreground hover:text-foreground">
            <CalendarDays className="w-4 h-4" />
          </button>
        </PopoverTrigger>
        <input data-testid={tid} disabled={disabled} inputMode="numeric" autoComplete="off" placeholder={placeholder || "gg.aa.yyyy"} value={metin} onChange={yaz} onBlur={birak}
          onKeyDown={(e) => { if (e.key === "ArrowDown" && e.altKey) setAcik(true); }} className="h-full w-full min-w-0 bg-transparent pr-3 outline-none placeholder:text-muted-foreground" />
      </div>
      <PopoverContent className="w-auto p-0" align="start" onOpenAutoFocus={(e) => e.preventDefault()}>
        <Calendar mode="single" locale={tr} weekStartsOn={1} selected={secili} defaultMonth={secili} onSelect={sec} disabled={kapali} />
        <div className="flex justify-between gap-2 border-t border-white/10 p-2">
          <button type="button" className="text-xs px-2 py-1 rounded hover:bg-white/10" onClick={() => sec(new Date())} data-testid={tid ? `${tid}-bugun` : undefined}>Bugün</button>
          {!required && <button type="button" className="text-xs px-2 py-1 rounded hover:bg-white/10 text-muted-foreground" onClick={() => sec(null)}>Temizle</button>}
        </div>
      </PopoverContent>
    </Popover>
  );
};
